import { useMemo, useState, MouseEvent, useRef } from 'react'
import cns from 'classnames'
import { useClickOutside } from './useClickOutside'

import * as cn from './styles.module.scss'

export type Option = {
  value: string
  label: string
}

type Props = {
  value: string
  options: Option[]
  onChange: (value: string) => void
}

export const Select = (props: Props) => {
  const { value, options, onChange } = props
  const [isOpen, setIsOpen] = useState(false)
  const labelRef = useRef(null)
  const optionsRef = useRef(null)
  const toggleOptions = () => setIsOpen(value => !value)
  useClickOutside({
    refs: [labelRef, optionsRef],
    onClickOutside: () => setIsOpen(false),
  })

  const selectedOptionLabel = useMemo(() => {
    return options.find(option => option.value === value)?.label
  }, [value, options])

  const handleChange = (event: MouseEvent<HTMLDivElement>) => {
    setIsOpen(false)
    onChange(event.currentTarget.id)
  }

  return (
    <div className={cn.root}>
      <div
        className={cns(cn.label, { [cn.open]: isOpen })}
        onClick={toggleOptions}
        ref={labelRef}
      >
        {selectedOptionLabel}
      </div>
      {isOpen && (
        <div className={cn.options} ref={optionsRef}>
          {options.map(option => (
            <div
              key={option.value}
              id={option.value}
              onClick={handleChange}
              className={cn.option}
            >
              {option.label}
            </div>
          ))}
        </div>
      )}
    </div>
  )
}
